import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let ipResolverApi = {};

ipResolverApi.checkIp = (data) => {
  return axios.post(`${config.url}/webmaster/ip/resolve`, data, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

ipResolverApi.fetchSavedIps = () => {
  return axios.post(`${config.url}/webmaster/ip/saved`, {}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

ipResolverApi.fetchRecentIps = () => {
  const formData = {
    limit:10,
    page:1
  }

  return axios.post(`${config.url}/webmaster/ip/recent`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};




export default ipResolverApi;
